import React from 'react'
import { Dropdown } from '@wemolo/components'
import './WemoloDropdown.css'

type DropdownProps = React.ComponentProps<typeof Dropdown>
type ExtraProps = { menuPlacement?: 'top' | 'bottom' }

export const WemoloDropdown = ({ className, menuPlacement = 'bottom', ...rest }: DropdownProps & ExtraProps) => {
    const placementClass = menuPlacement === 'top' ? 'wemolo-dropdown--menu-top' : ''
    const merged = ['wemolo-dropdown-fit', placementClass, className].filter(Boolean).join(' ')
    return <Dropdown {...(rest as DropdownProps)} className={merged} />
}
